import { URL, handleErrors } from "./depannageActions"
import { showToast } from "./toastActions"
import { catchApiError } from "./apiHelpers"

//////////////////////////////////////////////////////////////
//        Jours fériés / chômés matérialisés (GE-11)        //
//////////////////////////////////////////////////////////////
// api/jours_feries : GET payload complet {canton, cantons, regles_actives,
// catalogue, preselections, jours}, POST actions {sauver_reglage | generer |
// ajouter}, DELETE {id}. Chaque mutation renvoie le payload frais.

export const FETCH_FERIES_BEGIN = "FETCH_FERIES_BEGIN"
export const FETCH_FERIES_ERROR = "FETCH_FERIES_ERROR"
export const FETCH_FERIES_SUCCESS = "FETCH_FERIES_SUCCESS"

export const fetchFeriesSuccess = (data) => ({
	type: FETCH_FERIES_SUCCESS,
	payload: { data },
})

export function fetchJoursFeries() {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch({ type: FETCH_FERIES_BEGIN })
		return fetch(`${URL}api/jours_feries`, {
			headers: { Authorization: `Bearer ${token}` },
		})
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => dispatch(fetchFeriesSuccess(json)))
			.catch(
				catchApiError(dispatch, (error) => ({
					type: FETCH_FERIES_ERROR,
					payload: { error },
				})),
			)
	}
}

export function postJoursFeries(payload, successMessage) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		return fetch(`${URL}api/jours_feries`, {
			method: "post",
			headers: {
				Accept: "application/json, text/plain",
				"Content-type": "application/json",
				Authorization: `Bearer ${token}`,
			},
			body: JSON.stringify(payload),
		})
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch(fetchFeriesSuccess(json))
				if (successMessage) dispatch(showToast("success", successMessage))
				return json
			})
			.catch(catchApiError(dispatch))
	}
}

export function deleteJourFerie(id) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		return fetch(`${URL}api/jours_feries`, {
			method: "delete",
			headers: {
				Accept: "application/json, text/plain",
				"Content-type": "application/json",
				Authorization: `Bearer ${token}`,
			},
			body: JSON.stringify({ id }),
		})
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch(fetchFeriesSuccess(json))
				dispatch(
					showToast(
						"success",
						"Jour supprimé — « Générer » ne le recréera pas",
					),
				)
				return json
			})
			.catch(catchApiError(dispatch))
	}
}
